import React, { useEffect, useState, useCallback } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { hrApi } from "../../services/hrApi";
import HROrgChartTree from "../../components/hr/HROrgChartTree";

export default function HROrgChartPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [authReady, setAuthReady] = useState(false);
  const [globalExpanded, setGlobalExpanded] = useState(true);

  const loadOrgChart = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const res = await hrApi.getOrgChart();
      setRows(res?.data?.data || []);
    } catch (err) {
      console.error("ORG CHART ERROR:", err);
      setError(err?.response?.data?.message || err.message || "Failed to load org chart.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const auth = getAuth();

    const unsub = onAuthStateChanged(auth, (user) => {
      setAuthReady(true);

      if (!user) {
        setError("You are not authenticated.");
        setLoading(false);
      }
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    if (!authReady) return;
    if (!auth.currentUser) return;

    loadOrgChart();
  }, [authReady, loadOrgChart]);

  if (loading) return <div className="p-6">Loading org chart...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">HR Org Chart</h1>
        <p className="text-sm text-gray-500 mt-1">
          Organization structure based on positions and assignments.
        </p>
      </div>

      <HROrgChartTree rows={rows} reloadOrgChart={loadOrgChart} />
    </div>
  );
}